<template>
  <b-modal id="modal-approval" ref="modal" size="xl" title="Approval" @show="setData" :hide-footer="hideButton">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend>General Information </legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Request Date</label>
                <div class="col-md-6 mb-3">
                  {{detail.request_date}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project</label>
                <div class="col-md-6 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Activity Start</label>
                <div class="col-md-6 mb-3">
                  {{detail.activity_start}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">End of Activity</label>
                <div class="col-md-6 mb-3">
                  {{detail.activity_end}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nominal Cash Advance</label>
                <div class="col-md-5 mb-3">
                  {{detail.curr_code}} {{detail.cash_advance_amount}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Cash Advance Use</label>
                <div class="col-md-6 mb-3">
                  {{detail.cash_advance_purpose}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mini TOR/Breakdown Budget</label>
                <div class="col-md-6 mb-3">
                  <a :href="detail.link_file" target="_blank">{{detail.attachment_enc}}</a>
                </div>
              </div>

              <hr>
              <legend>Approval Information</legend>

              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="detail.ca_stat_id !== 0"></list-supervisor-finish>
              <list-supervisor  v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>

    </b-form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";

export default {
  name: "CashAdvanceApproval",
  components:{
    ListSupervisorFinish,
    ListSupervisor,
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      stat_id:1,
      hideButton:true,
      detail:{},
      list_supervisor:[]
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        this.getDetail()
      }, 100)
    },
    handleOk(e){
      e.preventDefault()
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.cash_advance.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(err=>{
        this.$root.$children[0].errorMessage(err.response.data.message)
      })
    },
    getDetail(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.cash_advance.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
          this.hideButton = (this.detail.emp_id == this.$store.getters.empId) ? true :false
          if(this.detail.ca_stat_id !== 1) this.getListSupervisor()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getListSupervisor(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.cash_advance.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  }
}
</script>